var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-sheet',[_c('v-toolbar',{attrs:{"dense":"","elevation":"0"}},[_c('v-toolbar-title',{staticClass:"subtitle-2 text-capitalize"},[_vm._v(" "+_vm._s(_vm.minorSettings.license_alternative_caption)+" ")]),_c('v-spacer')],1),_c('v-divider'),_c('router-view',{attrs:{"name":"view"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }